import { ref, computed } from 'vue';
function useTypeform() {
  const typeform = ref(null);
  const promiseResolve = ref(null);
  const hasLoadedPromise = new Promise(resolve => promiseResolve.value = resolve);
  async function load() {
    const typeformImport = await import('../external/@typeform/embed/build/component-lib.esm.js');
    typeform.value = typeformImport.default || typeformImport;
    promiseResolve.value();
  }
  const hasLoaded = computed(() => typeform.value !== null);
  load();
  return {
    typeform,
    hasLoaded,
    hasLoadedPromise
  };
}
export { useTypeform };